module.exports = __webpack_public_path__ + "img/printLabel.d7f6c785.svg";